// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import Alpine from "alpinejs";

// Import each AlpineJS controller within src below
import "./src/layout";
import "./src/tabs";
import "./src/home";
import "./src/workOrdersForm";

window.Alpine = Alpine;

Alpine.start();
